"use client";

import { useEffect } from "react";

export default function ScrollTopButton() {
  useEffect(() => {
    const btn = document.getElementById("scrollTopBtn") as HTMLButtonElement;
    const path = document.querySelector<SVGCircleElement>("#scrollProgressPath");

    if (!btn || !path) return;

    const radius = 49;
    const circumference = 2 * Math.PI * radius;

    path.style.strokeDasharray = `${circumference}`;
    path.style.strokeDashoffset = `${circumference}`;

    const updateScroll = () => {
      const scrollTop = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollTop / height;
      const offset = circumference - progress * circumference;

      path.style.strokeDashoffset = offset.toString();

      if (scrollTop > 200) {
        btn.classList.add("is-active");
      } else {
        btn.classList.remove("is-active");
      }
    };

    window.addEventListener("scroll", updateScroll);
    updateScroll();

    return () => window.removeEventListener("scroll", updateScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      id="scrollTopBtn"
      className="gh-scroll-top-btn"
      onClick={scrollToTop}
    >
      {/* Arrow */}
      <svg width="32" height="32" viewBox="0 0 32 32" className="gh-scroll-top-arrow">
        <path
          d="M9.6 19.2L16 12.8L22.4 19.2"
          stroke="currentColor"  // <-- inherits color from CSS
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Progress Circle */}
      <svg className="gh-scroll-top-progress" viewBox="0 0 100 100">
        <circle id="scrollProgressPath" cx="50" cy="50" r="49" />
      </svg>
    </button>
  );
}